var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.842102,
    y: 0.0527344,
    width: 49.6842,
    height: 49.6842,
    rx: 24.8421,
    fill: "#D7DBEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5848 22.8787C15.6633 21.0987 17.7285 21.3572 20.3232 21.3572H31.6264C33.3686 21.3572 35.7427 21.7884 37.2695 20.8001C40.0077 19.0272 40.2985 12.299 37.6749 10.284C36.1428 9.10739 34.0905 9.40192 32.2785 9.40192H19.8885C17.8289 9.40192 15.7685 9.28302 14.4115 11.1496C12.4621 13.8312 13.5848 19.6943 13.5848 22.8787Z",
    fill: "#3B519F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.585 41.138C15.4326 38.9102 16.8233 35.9368 20.106 35.5266C24.1114 35.0262 28.4579 35.4864 32.496 35.4864C34.5427 35.4864 36.8262 35.6414 38.316 33.9553C40.3717 31.6288 40.0965 25.4531 37.2772 23.8283C35.7374 22.941 33.5565 23.3144 31.8439 23.3138C28.0117 23.3123 24.1612 23.4044 20.3234 23.3105C18.3879 23.2634 16.269 22.9466 14.7433 24.4721C13.3498 25.8659 13.585 27.8159 13.585 29.6175V41.138Z",
    fill: "#0BA9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLogo);
export default __webpack_public_path__ + "static/media/BankLogo.cc977a3034ec6ea6879e957863ff6937.svg";
export { ForwardRef as ReactComponent };